'use client';

import { c as _c } from "react/compiler-runtime";
import LogoOverlayThumbnailStack from '@/app/[locale]/(worlds)/[roomId]/components/LogoOverlayThumbnailStack';
import IconLogoOverlay from '@/components/assets/icon_logo_overlay.svg';
import { LogoOverlayContentKind, type LogoOverlayContentModel } from '@/lib/logo-overlay';
import { cn } from '@/lib/utils';
import type { RecommendRoom } from '@/services/cms';
type LogoOverlayButtonProps = {
  /** Omit for the static fallback pill (no flip, no thumbnail, no click). */
  overlayModel?: LogoOverlayContentModel | null;
  /** First resolved room from the prefetch; `undefined` while loading. */
  firstRoom?: RecommendRoom;
};
export default function LogoOverlayButton(t0) {
  const $ = _c(14);
  const {
    overlayModel,
    firstRoom
  } = t0;
  const thumbnailShape = overlayModel?.contentKind === LogoOverlayContentKind.GAME ? "square" : "landscape";
  const t1 = overlayModel ? "cursor-pointer" : "cursor-default";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("animate-logo-overlay-glow-pulse relative w-fit rounded-3xl [transition:transform_100ms_ease-out,box-shadow_150ms_ease-out] hover:scale-105 hover:shadow-[0_0_22px_rgba(255,255,255,0.55)] hover:[animation-name:none]", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="pointer-events-none absolute inset-0 z-interactive overflow-hidden rounded-3xl" aria-hidden={true}><div className="animate-logo-overlay-shine-sweep absolute inset-0 bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,0.25)_50%,transparent_100%)]" /></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IconLogoOverlay />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== firstRoom?.image || $[5] !== firstRoom?.title || $[6] !== overlayModel || $[7] !== thumbnailShape) {
    t5 = overlayModel && <LogoOverlayThumbnailStack thumbnailUrl={firstRoom?.image} alt={firstRoom?.title ?? ""} thumbnailShape={thumbnailShape} />;
    $[4] = firstRoom?.image;
    $[5] = firstRoom?.title;
    $[6] = overlayModel;
    $[7] = thumbnailShape;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <div className="relative flex items-center justify-center gap-1.5 rounded-3xl bg-black/40 px-4 py-2 backdrop-blur-sm">{t4}{t5}</div>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t6) {
    t7 = <div className={t2}>{t3}{t6}</div>;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}